import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_close.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_search.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1705a4ea")

_pushScopeId("data-v-1705a4ea")
const _hoisted_1 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "absolute left-0 mt-2 bg-white border border-gray-lp-900 rounded-xl shadow-lg z-50 flex flex-col",
  style: {"width":"300px"}
}
const _hoisted_5 = { class: "py-2 px-3 flex flex-col gap-2 text-black-lp-100" }
const _hoisted_6 = { class: "text-sm font-semibold" }
const _hoisted_7 = { class: "gap-3" }
const _hoisted_8 = { class: "w-full flex flex-row flex-nowrap relative border rounded-md border-gray-lp-2100 text-black-lp-300 py-2.5 px-4 items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 h-5 max-w-none",
  alt: "search-icon"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_11 = {
  key: 1,
  class: "text-gray-lp-300 flex justify-center text-center items-center py-2"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "flex flex-row items-center gap-3 px-0.5 py-2 relative" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_15 = { class: "flex flex-row border-t border-[rgba(26,20,33,0.15)] gap-2 py-2 px-2" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "absolute left-0 mt-2 bg-white border border-gray-lp-900 rounded-xl shadow-lg z-50 flex flex-col",
  style: {"width":"300px"}
}
const _hoisted_19 = { class: "py-2 px-3 flex flex-col gap-2 text-black-lp-100" }
const _hoisted_20 = { class: "text-sm font-semibold" }
const _hoisted_21 = { class: "gap-3" }
const _hoisted_22 = { class: "w-full flex flex-row flex-nowrap relative border rounded-md border-gray-lp-2100 text-black-lp-300 py-2.5 px-4 items-center gap-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 h-5 max-w-none",
  alt: "search-icon"
}, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_25 = {
  key: 1,
  class: "text-gray-lp-300 flex justify-center text-center items-center py-2"
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = {
  class: "select overflow-auto",
  style: {"max-height":"350px"}
}
const _hoisted_28 = { class: "flex flex-row items-center gap-3 px-0.5 py-2 relative" }
const _hoisted_29 = { class: "flex flex-row border-t border-[rgba(26,20,33,0.15)] gap-2 py-2 px-2" }
const _hoisted_30 = {
  key: 0,
  class: "flex flex-row gap-3 items-center"
}
const _hoisted_31 = { class: "relative" }
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "absolute left-0 mt-2 bg-white border border-gray-lp-900 rounded-xl shadow-lg z-50 flex flex-col",
  style: {"width":"300px"}
}
const _hoisted_34 = { class: "py-2 px-3 flex flex-col gap-2 text-black-lp-100" }
const _hoisted_35 = { class: "text-sm font-semibold" }
const _hoisted_36 = { class: "flex flex-col font-normal text-sm" }
const _hoisted_37 = { class: "flex flex-row items-center gap-3 py-2 relative" }
const _hoisted_38 = { for: "checkbox-min-weight" }
const _hoisted_39 = { class: "flex flex-row items-center gap-3 py-2 relative" }
const _hoisted_40 = { for: "checkbox-min-weight" }
const _hoisted_41 = { class: "flex flex-row border-t border-[rgba(26,20,33,0.15)] gap-2 py-2 px-2" }
const _hoisted_42 = { class: "relative" }
const _hoisted_43 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_44 = {
  key: 0,
  class: "absolute left-0 mt-2 bg-white border border-gray-lp-900 rounded-xl shadow-lg z-50 py-2 px-3 flex flex-col gap-2 text-black-lp-100",
  style: {"width":"300px"}
}
const _hoisted_45 = { class: "text-sm font-semibold" }
const _hoisted_46 = { class: "flex flex-col font-normal text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["rounded-2xl border flex flex-row gap-1 px-3 py-2 items-center cursor-pointer", 
          `${
            _ctx.isOpenDestination
              ? 'border-red-lp-2400 bg-gray-lp-2900'
              : _ctx.form.destination.length
              ? 'border-red-lp-2400 bg-red-lp-1300'
              : 'border-red-lp-900 bg-gray-lp-2900'
          }`
        ],
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleDestination && _ctx.toggleDestination(...args)))
      }, [
        _createVNode("img", {
          src: 
            require(`@/app/ui/assets/svg/${
              _ctx.form.destination.length || _ctx.isOpenDestination
                ? 'ics_o_destination_active'
                : 'ics_o_destination'
            }.svg`)
          ,
          alt: "destination"
        }, null, 8, ["src"]),
        _createVNode("span", {
          class: ["font-medium text-sm", 
            `${
              _ctx.form.destination.length || _ctx.isOpenDestination
                ? 'text-red-lp-2400'
                : 'text-black-lp-100'
            }`
          ]
        }, _toDisplayString(_ctx.form.destination.length ? _ctx.destinationFilterTitle : _ctx.$t("cargoV2.components.common.destinationCity")), 3),
        (_ctx.form.destination.length)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetDestination && _ctx.resetDestination(...args)))
            }, [
              _hoisted_3
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.isOpenDestination)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.selectDestinationCity")), 1),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("input", {
                    value: _ctx.destinationSearch,
                    onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSearchDestinationCity && _ctx.onSearchDestinationCity(...args))),
                    placeholder: _ctx.$t('cargoV2.components.filterRtc.searchDestinationCityHere'),
                    class: "flex-shrink w-full bg-white rounded-md leading-tight font-normal focus:outline-none text-black-lp-300",
                    autocomplete: "nope"
                  }, null, 40, ["value", "placeholder"])
                ]),
                (_ctx.isLoadingCity && !_ctx.loadingInfiniteScroll)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode(_component_Skeleton, {
                        height: "1.3rem",
                        width: "88%",
                        class: "my-2"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "1.3rem",
                        width: "94%",
                        class: "my-2"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "1.3rem",
                        width: "83%",
                        class: "my-2"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "1.3rem",
                        width: "97%",
                        class: "my-2"
                      })
                    ]))
                  : (_ctx.optionDestinationCity.length === 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.notFound")), 1))
                    : (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode("div", {
                          onScrollend: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchInfiniteScrollDestination && _ctx.fetchInfiniteScrollDestination(...args)), ["prevent"])),
                          class: "select overflow-auto",
                          style: {"max-height":"350px"}
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionDestinationCity, (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: item.id,
                              ref: `option${index}`,
                              class: "hover:bg-gray-lp-700 text-black-lp-100"
                            }, [
                              _createVNode("div", _hoisted_13, [
                                _createVNode(_component_Checkbox, {
                                  id: `checkbox-destination-${item.id}`,
                                  modelValue: item.isChecked,
                                  "onUpdate:modelValue": [($event: any) => (item.isChecked = $event), ($event: any) => (_ctx.onCheckDestination($event, item))],
                                  binary: true
                                }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]),
                                _createVNode("label", {
                                  for: `checkbox-destination-${index}`
                                }, _toDisplayString(item.label), 9, ["for"])
                              ])
                            ], 512))
                          }), 128)),
                          (_ctx.isLoadingCity && _ctx.loadingInfiniteScroll)
                            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                _createVNode(_component_Skeleton, {
                                  height: "1.3rem",
                                  width: "88%",
                                  class: "my-2"
                                }),
                                _createVNode(_component_Skeleton, {
                                  height: "1.3rem",
                                  width: "94%",
                                  class: "my-2"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 32)
                      ]))
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("button", {
                class: "w-full text-red-lp-2400 font-semibold text-14px items-center justify-center cursor-pointer py-1.5",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetDestination && _ctx.resetDestination(...args)))
              }, _toDisplayString(_ctx.$t("cargoV2.components.common.reset")), 1),
              _createVNode("button", {
                class: "w-full bg-red-lp-2400 text-white rounded-lg font-semibold text-14px py-1.5",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectDestination && _ctx.selectDestination(...args)))
              }, _toDisplayString(_ctx.$t("cargoV2.components.common.apply")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_click_outside, () => (_ctx.isOpenDestination = false)]
    ]),
    _withDirectives(_createVNode("div", _hoisted_16, [
      _createVNode("div", {
        class: ["rounded-2xl border flex flex-row gap-1 px-3 py-2 items-center cursor-pointer", 
          `${
            _ctx.isOpenClient
              ? 'border-red-lp-2400 bg-gray-lp-2900'
              : _ctx.form.client.length
              ? 'border-red-lp-2400 bg-red-lp-1300'
              : 'border-red-lp-900 bg-gray-lp-2900'
          }`
        ],
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleClient && _ctx.toggleClient(...args)))
      }, [
        _createVNode("img", {
          src: 
            require(`@/app/ui/assets/svg/${
              _ctx.form.client.length || _ctx.isOpenClient
                ? 'ics_o_profile_active'
                : 'ics_o_profile'
            }.svg`)
          ,
          alt: "client"
        }, null, 8, ["src"]),
        _createVNode("span", {
          class: ["font-medium text-sm", 
            `${
              _ctx.form.client.length || _ctx.isOpenClient
                ? 'text-red-lp-2400'
                : 'text-black-lp-100'
            }`
          ]
        }, _toDisplayString(_ctx.form.client.length ? _ctx.clientFilterTitle : _ctx.$t("cargoV2.components.filterRtc.client")), 3),
        (_ctx.form.client.length)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetClient && _ctx.resetClient(...args)))
            }, [
              _hoisted_17
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.isOpenClient)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.selectClient")), 1),
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode("input", {
                    value: _ctx.clientSearch,
                    onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSearchClient && _ctx.onSearchClient(...args))),
                    placeholder: _ctx.$t('cargoV2.components.filterRtc.searchClientHere'),
                    class: "flex-shrink w-full bg-white rounded-md leading-tight font-normal focus:outline-none text-black-lp-300",
                    autocomplete: "nope"
                  }, null, 40, ["value", "placeholder"])
                ]),
                (_ctx.isLoadingClientPartner)
                  ? (_openBlock(), _createBlock("div", _hoisted_24, [
                      _createVNode(_component_Skeleton, {
                        height: "1.3rem",
                        width: "88%",
                        class: "my-2"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "1.3rem",
                        width: "94%",
                        class: "my-2"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "1.3rem",
                        width: "83%",
                        class: "my-2"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "1.3rem",
                        width: "97%",
                        class: "my-2"
                      })
                    ]))
                  : (_ctx.optionClientParentData.length === 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.notFound")), 1))
                    : (_openBlock(), _createBlock("div", _hoisted_26, [
                        _createVNode("div", _hoisted_27, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionClientParentData, (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: item.id,
                              ref: `option-client${index}`,
                              class: "hover:bg-gray-lp-700 text-black-lp-100"
                            }, [
                              _createVNode("div", _hoisted_28, [
                                _createVNode(_component_Checkbox, {
                                  id: `checkbox-client-${item.id}`,
                                  modelValue: item.isChecked,
                                  "onUpdate:modelValue": [($event: any) => (item.isChecked = $event), ($event: any) => (_ctx.onCheckClient($event, item))],
                                  binary: true
                                }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]),
                                _createVNode("label", {
                                  for: `checkbox-client-${index}`
                                }, _toDisplayString(item.label), 9, ["for"])
                              ])
                            ], 512))
                          }), 128))
                        ])
                      ]))
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("button", {
                class: "w-full text-red-lp-2400 font-semibold text-14px items-center justify-center cursor-pointer py-1.5",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetClient && _ctx.resetClient(...args)))
              }, _toDisplayString(_ctx.$t("cargoV2.components.common.reset")), 1),
              _createVNode("button", {
                class: "w-full bg-red-lp-2400 text-white rounded-lg font-semibold text-14px py-1.5",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.selectClient && _ctx.selectClient(...args)))
              }, _toDisplayString(_ctx.$t("cargoV2.components.common.apply")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_click_outside, () => (_ctx.isOpenClient = false)]
    ]),
    (_ctx.isPlane)
      ? (_openBlock(), _createBlock("div", _hoisted_30, [
          _withDirectives(_createVNode("div", _hoisted_31, [
            _createVNode("div", {
              class: ["rounded-2xl border flex flex-row gap-1 px-3 py-2 items-center cursor-pointer", 
            `${
              _ctx.isOpenMinimum
                ? 'border-red-lp-2400 bg-gray-lp-2900'
                : _ctx.form.hasMinimumWeight || _ctx.form.hasMinimumPieces
                ? 'border-red-lp-2400 bg-red-lp-1300'
                : 'border-red-lp-900 bg-gray-lp-2900'
            }`
          ],
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toggleMinimum && _ctx.toggleMinimum(...args)))
            }, [
              _createVNode("img", {
                src: 
              require(`@/app/ui/assets/svg/${
                _ctx.form.hasMinimumWeight || _ctx.form.hasMinimumPieces || _ctx.isOpenMinimum
                  ? 'ics_o_min_circle_active'
                  : 'ics_o_min_circle'
              }.svg`)
            ,
                alt: "minimum"
              }, null, 8, ["src"]),
              _createVNode("span", {
                class: ["font-medium text-sm", 
              `${
                _ctx.form.hasMinimumWeight || _ctx.form.hasMinimumPieces || _ctx.isOpenMinimum
                  ? 'text-red-lp-2400'
                  : 'text-black-lp-100'
              }`
            ]
              }, _toDisplayString(_ctx.minimumFilterTitle), 3),
              (_ctx.form.hasMinimumWeight || _ctx.form.hasMinimumPieces)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.resetMinimum && _ctx.resetMinimum(...args)))
                  }, [
                    _hoisted_32
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.isOpenMinimum)
              ? (_openBlock(), _createBlock("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.selectMinimumLimit")), 1),
                    _createVNode("div", _hoisted_36, [
                      _createVNode("div", _hoisted_37, [
                        _createVNode(_component_Checkbox, {
                          id: "checkbox-min-weight",
                          modelValue: _ctx.tempHasMinimumWeight,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.tempHasMinimumWeight = $event)),
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.minimumWeight")), 1)
                      ]),
                      _createVNode("div", _hoisted_39, [
                        _createVNode(_component_Checkbox, {
                          id: "checkbox-min-weight",
                          modelValue: _ctx.tempHasMinimumPieces,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.tempHasMinimumPieces = $event)),
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.minimumPieces")), 1)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_41, [
                    _createVNode("button", {
                      class: "w-full text-red-lp-2400 font-semibold text-14px items-center justify-center cursor-pointer py-1.5",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.resetMinimum && _ctx.resetMinimum(...args)))
                    }, _toDisplayString(_ctx.$t("cargoV2.components.common.reset")), 1),
                    _createVNode("button", {
                      class: "w-full bg-red-lp-2400 text-white rounded-lg font-semibold text-14px py-1.5",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.selectMinimum && _ctx.selectMinimum(...args)))
                    }, _toDisplayString(_ctx.$t("cargoV2.components.common.apply")), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_directive_click_outside, () => (_ctx.isOpenMinimum = false)]
          ]),
          _withDirectives(_createVNode("div", _hoisted_42, [
            _createVNode("div", {
              class: ["rounded-2xl border flex flex-row gap-1 px-3 py-2 items-center cursor-pointer", 
            `${
              _ctx.isOpenSort
                ? 'border-red-lp-2400 bg-gray-lp-2900'
                : _ctx.form.sort
                ? 'border-red-lp-2400 bg-red-lp-1300'
                : 'border-red-lp-900 bg-gray-lp-2900'
            }`
          ],
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleSort && _ctx.toggleSort(...args)))
            }, [
              _createVNode("img", {
                src: 
              require(`@/app/ui/assets/svg/${
                _ctx.form.sort || _ctx.isOpenSort ? 'ics_o_sort_active' : 'ics_o_sort'
              }.svg`)
            ,
                alt: "sort"
              }, null, 8, ["src"]),
              _createVNode("span", {
                class: ["font-medium text-sm", 
              `${
                _ctx.form.sort || _ctx.isOpenSort ? 'text-red-lp-2400' : 'text-black-lp-100'
              }`
            ]
              }, _toDisplayString(_ctx.sortFilterTitle), 3),
              (_ctx.form.sort)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.resetSort && _ctx.resetSort(...args)))
                  }, [
                    _hoisted_43
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.isOpenSort)
              ? (_openBlock(), _createBlock("div", _hoisted_44, [
                  _createVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("cargoV2.components.searchFlightFilter.sortFrom")), 1),
                  _createVNode("div", _hoisted_46, [
                    _createVNode("span", {
                      class: "py-2 cursor-pointer",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.selectSort('terdekat')))
                    }, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.cotNearest")), 1),
                    _createVNode("span", {
                      class: "py-2 cursor-pointer",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.selectSort('terlama')))
                    }, _toDisplayString(_ctx.$t("cargoV2.components.filterRtc.cotLongest")), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_directive_click_outside, () => (_ctx.isOpenSort = false)]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})